import { render } from "./LocationCard.vue?vue&type=template&id=0a884cee&scoped=true"
import script from "./LocationCard.vue?vue&type=script&lang=js"
export * from "./LocationCard.vue?vue&type=script&lang=js"

import "./LocationCard.vue?vue&type=style&index=0&id=0a884cee&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a884cee"]])

export default __exports__